
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temi/tutti",
      function () {
        return require("private-next-pages/temi/tutti.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temi/tutti"])
      });
    }
  